import {
  LogoEmajinGolfImage,
  LogoFuturwiseImage,
  LogoMorpheusImage,
  LogoNetworkOSImage,
  LogoSentr3Image,
  LogoWorkAxleImage,
} from 'Assets/Image/CompanyLogos'
import {
  EmajinGolfImage,
  FuturwiseImage,
  MorpheusNetworkImage,
  NetworkOSImage,
  Sentry3Image,
  WorkAxleImage,
} from 'Assets/Image/Projects'

import { ProjectPreview } from 'Types/projectPreview'

import { PROJECT_BENEFITS } from './projectBenefits'
import { ProjectId, Tags } from './types'

export const LOCAL_PROJECTS: ProjectPreview[] = [
  {
    id: ProjectId.WorkAxle,
    company: 'WorkAxle',
    industry: 'Workforce Management',
    title: 'We fully automated workforce scheduling',
    description:
      'We delivered a real-time scheduling engine with shift tracking, employee availability, and location-aware clock-ins - making workforce ops effortless for teams across North America.',
    benefits: PROJECT_BENEFITS[ProjectId.WorkAxle],
    logoSrc: LogoWorkAxleImage.src,
    imageSrc: WorkAxleImage.src,
    slug: 'workaxle',
    tags: [Tags.Web, Tags.Mobile, Tags.API, Tags.Design],
  },
  {
    id: ProjectId.Morpheus,
    company: 'Morpheus.Network',
    industry: 'Supply Chain & Logistics',
    title: 'We ensure trust in the global supply chain',
    description:
      'We rebuilt the platform with smart contract automation, real-time tracking, and compliance workflows—bridging physical and digital layers across international logistics.',
    benefits: PROJECT_BENEFITS[ProjectId.Morpheus],
    logoSrc: LogoMorpheusImage.src,
    imageSrc: MorpheusNetworkImage.src,
    slug: 'morpheus',
    tags: [Tags.Blockchain, Tags.Web, Tags.API, Tags.Automation],
  },
  {
    id: ProjectId.Sentr3,
    company: 'Sentr3',
    industry: 'Web3 Social Networking',
    title: 'We connected crypto communities',
    description:
      'We launched a Web3-native platform that lets creators reward holders with exclusive content, token-gated chats, and event access—proving NFTs can go far beyond art.',
    benefits: PROJECT_BENEFITS[ProjectId.Sentr3],
    logoSrc: LogoSentr3Image.src,
    imageSrc: Sentry3Image.src,
    slug: 'sentr3',
    tags: [Tags.Blockchain, Tags.Web, Tags.Mobile, Tags.Design],
  },
  {
    id: ProjectId.EmajinGolf,
    company: 'Emajin.Golf',
    industry: 'Business Networking (Golf)',
    title: 'We powered the business club for modern golfers',
    description:
      'We built a premium membership app with bookings, newsfeeds, messaging, and live RSVPs - helping Emajin scale its exclusive golf network across Australia and beyond.',
    benefits: [],
    logoSrc: LogoEmajinGolfImage.src,
    imageSrc: EmajinGolfImage.src,
    slug: 'emajingolf-app',
    tags: [Tags.Mobile, Tags.Web, Tags.Design, Tags.API],
  },
  {
    id: ProjectId.FuturWise,
    company: 'Futurwise',
    industry: 'Foresight & AI',
    title: 'We trained AI to think like a futurist',
    description:
      'We developed a prompt engineering interface, real-time chat, and publishing tools to distill expert foresight into actionable signals - powered by GPT, Mistral and custom datasets.',
    benefits: [],
    logoSrc: LogoFuturwiseImage.src,
    imageSrc: FuturwiseImage.src,
    slug: 'futurwise',
    tags: [Tags.AI, Tags.Web, Tags.Research, Tags.Design],
  },
  {
    id: ProjectId.NetworkOS,
    company: 'NetworkOS',
    industry: 'Relationship Management (CRM)',
    title: 'We visualized business relationships',
    description:
      'We turned spreadsheets into live relationship graphs - helping consultants map influence, plan outreach, and drive action across their networks.',
    benefits: PROJECT_BENEFITS[ProjectId.NetworkOS],
    logoSrc: LogoNetworkOSImage.src,
    imageSrc: NetworkOSImage.src,
    slug: 'networkos',
    tags: [Tags.Web, Tags.Design, Tags.API, Tags.AI, Tags.Blockchain],
  },
]
